<template>
  <div
    v-if="error.hasError"
    class="step"
  >
    <h2>{{ errorTitle }}</h2>
    <p
      v-if="error.msg"
      class="subtitle text-medium"
      v-html="error.msg"
    />
    <p
      v-else
      class="subtitle text-medium"
    >
      Riprova più tardi
    </p>
    <div class="fieldset" />
    <div
      v-if="showGoToCompleteProfile && !preRegistration"
      class="actions"
    >
      <button
        class="button primary"
        @click="redirectToCompleteProfile()"
      >
        Completa Profilo
      </button>
    </div>
    <div
      v-else-if="preRegistration"
      class="actions"
    >
      <button
        class="button primary"
        @click="newPreRegistration()"
      >
        Nuova Registrazione
      </button>
    </div>
  </div>
  <div
    v-else
    class="step"
  >
    <h2>{{ successTitle }}</h2>
    <p class="subtitle text-medium" v-html="successText"></p>
    <div class="fieldset" />
    <div v-if="!preRegistration" class="actions">
      <LoginButton
        :params="dataParams"
        :class="'button block primary'"
        :is-autenticated="isAuthenticated"
      />
    </div>
    <div v-else-if="preRegistration" class="actions">
      <button
        class="button primary"
        @click="newPreRegistration()"
      >
        Nuova Registrazione
      </button>
    </div>
  </div>
</template>

<script>
import LoginButton from '../login-button.vue';

export default {
  name: 'TankYouPage',
  components: {
    LoginButton,
  },
  props: {
    error: {
      type: Object,
      default() {
        return {};
      },
    },
    completeProfile: {
      type: Boolean,
      default: false,
    },
    successMsg: {
      type: String,
      default: '',
    },
    preRegistration: {
      type: Boolean,
      default: false,
    },
    dataParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      params: {},
    };
  },
  computed: {
    showGoToCompleteProfile() {
      return this.error.code == 686;
    },
    errorTitle() {
      return this.completeProfile ? 'Si è verificato un errore' : 'Errore durante la registrazione';
    },
    successTitle() {
      return this.completeProfile || this.preRegistration ? 'Operazione conclusa con successo' : 'Registrazione completata';
    },
    successText() {
      if (this.preRegistration) {
        return 'Preregistrazione completata';
      }
      return this.successMsg;
    },
    isAuthenticated() {
      return this.$parent.isAuthenticated;
    },
  },
  watch: {},
  methods: {
    redirectToCompleteProfile() {
      window.location.href = '/private/complete-profile';
    },
    newPreRegistration() {
      window.location.reload();
    },
  },
};
</script>
